import theme from './theme.json';
import { ThemeConfig } from 'antd';

export const antdTheme: ThemeConfig = {
  token: {
    ...theme.token,
    // Core's persistent header sits at 1100. All Ant Design floating UI must
    // render above fixed platform chrome, including controls at the top edge.
    zIndexPopupBase: 2000,
  },
  components: {
    ...theme.components,
  },
  algorithm: undefined, // Will be set to dark algorithm in App.tsx
};

export const ouroraColors = theme.ouroraColors;

export default theme;
